import * as React from "react";
import "./RefreshButton.css";

/**
 * Reusable Refresh Button Component - Matching Ikhtisar style
 * @param {Object} props
 * @param {Function} props.onClick - Callback function when button is clicked
 * @param {boolean} props.loading - Loading state to show spinner and disable button
 * @param {string} props.label - Button label text (default: "Refresh")
 * @param {string} props.loadingLabel - Label text when loading (default: "Memuat...")
 * @param {Object} props.style - Additional custom styles
 */
const RefreshButton = ({
  onClick,
  loading = false,
  label = "Refresh",
  loadingLabel = "Memuat...",
  style = {},
}) => {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={`pb-refresh-btn ${loading ? "pb-refresh-btn--loading" : ""}`}
      style={style}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`pb-refresh-btn__icon ${loading ? "pb-refresh-btn__icon--spin" : ""}`}
      >
        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
      </svg>
      {loading ? loadingLabel : label}
    </button>
  );
};

export default RefreshButton;
